module.exports = __webpack_public_path__ + "assets/2c3a351cd9c86d7c3bda5de62572883c.png";